import * as React from "react"
import styled from "styled-components"

interface Props {
  status: "active" | "ended" | any
}

const Active = styled.div`
  width: 11px;
  height: 11px;
  border: ${(props) => `1px solid ${props.theme.colors.greyDark}`};
  background-color: ${(props) => props.theme.colors.greenDark};
  border-radius: 50%;
`

const Ended = styled.div`
  width: 11px;
  height: 11px;
  border: ${(props) => `1px solid ${props.theme.colors.greyDark}`};
  border-radius: 50%;
`

const Standby = styled.div`
  width: 11px;
  height: 11px;
  border: ${(props) => `1px solid ${props.theme.colors.greyDark}`};
  background-color: ${(props) => props.theme.colors.yellow};
  border-radius: 50%;
`

const TerminalStatusCircle: React.FunctionComponent<Props> = ({ status }) => {
  if (status === "active") {
    return <Active />
  } else if (status === "ended") {
    return <Ended />
  } else {
    return <Standby />
  }
}

export default TerminalStatusCircle
